<template>
    <div>
        <div class="container">
            <div class="jumbotron">
                <h1 class="display-4">Steel Detailer's Project Manager</h1>
                <p class="lead">Detailing shouldn't be 80% paperwork. Let us handle the filing for you</p>
                <hr class="my-4">
                <p class="lead">
                    <a class="btn btn-primary btn-lg" href="#" role="button">Learn More</a>
                </p>
            </div>

            <div class="row">
                <div class="col">
                    <div class="card">
                        <div class="card-header">
                            <h4 class="card-title">Information Management</h4>
                        </div>
                        <div class="card-body">
                            <p class="card-text">The Warboard Project Management System keeps track of your jobs information including built-in support for:</p>
                            <ul>
                                <li>RFI's</li>
                                <li>Transmittals</li>
                                <li>Change Orders</li>
                                <li>And More!</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card">
                        <div class="card-header">
                            <h4 class="card-title">Data Storage</h4>
                        </div>
                        <div class="card-body">
                            <p>All your data is easily accessible from one place. No more losing RFI forms, or forgetting to charge for added material.</p>
                            <p>The database is backed up every hour!</p>
                            <p>If you choose, you can add other members to project or a company account to share job data between several users!</p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card">
                        <div class="card-header">
                            <h4 class="card-title">Easy User Interface</h4>
                        </div>
                        <div class="card-body">
                            <p>Warboard Project Management is easy to use, plug and play.</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Home",
    }
</script>

<style scoped>

</style>